import { TChangePaymentDayInfo } from '@r1-frontend/api-domru/api-profile/v1/payments/change-payment-day-info/dto/ResponseDto';
import { TModelsTypes } from '@r1-frontend/api-domru/api-profile/v2/info/all';
import { IPaymentInfo, IPersonal, IProducts } from '@r1-frontend/api-domru/api-profile/v2/info/all/dto/ResponseDto';

import { IAction } from '@r1-frontend/shared/types/Redux';

import { EAuthTypes } from '../actionTypes';
import { EStage, IClientContacts, TAgreement, TAgreementsStatus } from '../reducer';

interface ILoginPayload {
    accessToken: string,
    refreshToken?: string,
}
export const setLogin = (payload: ILoginPayload): IAction<EAuthTypes.LOGIN, ILoginPayload> => ({
    type: EAuthTypes.LOGIN,
    payload,
});

export const setIsAuth = (isAuth: boolean): IAction<EAuthTypes.SET_IS_AUTH, boolean> => ({
    type: EAuthTypes.SET_IS_AUTH,
    payload: isAuth,
});

export const setErrorClientPayment = (isError: boolean | null): IAction<EAuthTypes.ERROR_CLIENT_PAYMENT, boolean | null> => ({
    type: EAuthTypes.ERROR_CLIENT_PAYMENT,
    payload: isError,
});

export const setFetchClientPayment = (isFetching: boolean | null): IAction<EAuthTypes.FETCH_CLIENT_PAYMENT, boolean | null> => ({
    type: EAuthTypes.FETCH_CLIENT_PAYMENT,
    payload: isFetching,
});


export const setLoginError = (error: string): IAction<EAuthTypes.SET_LOGIN_ERROR, string> => ({
    type: EAuthTypes.SET_LOGIN_ERROR,
    payload: error,
});

export type TSetClientInfoStage = {
    [key in TModelsTypes]?: EStage;
}

export const setClientInfoStage = (payload: TSetClientInfoStage): IAction<EAuthTypes.SET_CLIENT_INFO_STAGE, TSetClientInfoStage> => ({
    type: EAuthTypes.SET_CLIENT_INFO_STAGE,
    payload,
});

export const setClientPersonal = (personal: IPersonal): IAction<EAuthTypes.SET_CLIENT_PERSONAL, IPersonal> => ({
    type: EAuthTypes.SET_CLIENT_PERSONAL,
    payload: personal,
});

export const setClientPayment = (payment: IPaymentInfo): IAction<EAuthTypes.SET_CLIENT_PAYMENT, IPaymentInfo> => ({
    type: EAuthTypes.SET_CLIENT_PAYMENT,
    payload: payment,
});

export const setClientProducts = (products: IProducts): IAction<EAuthTypes.SET_CLIENT_PRODUCTS, IProducts> => ({
    type: EAuthTypes.SET_CLIENT_PRODUCTS,
    payload: products,
});

export const setClientContacts = (clientContacts: IClientContacts): IAction<EAuthTypes.SET_CLIENT_CONTACTS, IClientContacts> => ({
    type: EAuthTypes.SET_CLIENT_CONTACTS,
    payload: clientContacts,
});

export const clientContactsLoading = (isLoading: boolean): IAction<EAuthTypes.CLIENT_CONTACTS_LOADING, boolean> => ({
    type: EAuthTypes.CLIENT_CONTACTS_LOADING,
    payload: isLoading,
});

export const clientProductsLoading = (isLoading: boolean): IAction<EAuthTypes.CLIENT_PRODUCTS_LOADING, boolean> => ({
    type: EAuthTypes.CLIENT_PRODUCTS_LOADING,
    payload: isLoading,
});

export const setClientPaymentDayInfo = (
    dayInfo: TChangePaymentDayInfo,
): IAction<EAuthTypes.SET_PAYMENT_DAY_INFO, TChangePaymentDayInfo> => ({
    type: EAuthTypes.SET_PAYMENT_DAY_INFO,
    payload: dayInfo,
});

export const setCSRF = (
    token: string,
): IAction<EAuthTypes.SET_CSRF_TOKEN, string> => ({
    type: EAuthTypes.SET_CSRF_TOKEN,
    payload: token,
});

export const setAgreements = (
    agreements: TAgreement[],
): IAction<EAuthTypes.SET_AGREEMENTS, TAgreement[]> => ({
    type: EAuthTypes.SET_AGREEMENTS,
    payload: agreements,
});

export const setStatus = (
    status: TAgreementsStatus,
): IAction<EAuthTypes.SET_STATUS, TAgreementsStatus> => ({
    type: EAuthTypes.SET_STATUS,
    payload: status,
});

